import { render, staticRenderFns } from "./Contrario.vue?vue&type=template&id=9d1d6022&scoped=true&"
import script from "./Contrario.vue?vue&type=script&lang=js&"
export * from "./Contrario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1d6022",
  null
  
)

export default component.exports